import { render, staticRenderFns } from "./nonPaidVacation.vue?vue&type=template&id=72d8f8da"
import script from "./nonPaidVacation.vue?vue&type=script&lang=js"
export * from "./nonPaidVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports